<template>
  <v-app>
    <component :is="layout" />
    <!-- <core-filter />

    <core-toolbar />

    <core-drawer />

    <core-view /> -->
  </v-app>
</template>

<script>
  const defaultLayout = 'public'
  export default {
    computed: {
      layout () {
        return (this.$route.meta.layout || defaultLayout) + '-layout'
      }
    }
  }
</script>

<style lang="scss">
  // @import '@/styles/index.scss';
</style>
